<script lang="ts">
  import { pageStore, pageOptsStore, fn, suiPackageStore } from '@packages/stores'
  import { Pages } from '@packages/utils/enums'
  import { Wallet } from '@packages/ui'
  import { onMount } from 'svelte'
  import { get } from 'svelte/store'
  import { getClientTokenConfig } from '@lib/clients'

  const { getBalance } = get(fn)

  const { maxStoredValueToPurchase, minStoredValueToPurchase } = getClientTokenConfig()

  let balance: string = ''

  onMount(async () => {
    balance = await getBalance()
  })

  let selected: string = '10'

  const goToPayment = () => {
    pageOptsStore.set({
      subtitle: `Purchase stored value`,
      payments: {
        credenzaStoredValue: {
          disabled: true,
        },
      },
      assets: [
        {
          packageId: get(suiPackageStore),
          type: 'cred',
          amount: +selected,
        },
      ],
    })
    pageStore.set(Pages.PAYMENT)
  }
</script>

<Wallet
  bind:selected
  options={{
    title: `buy stored value`,
    description: `Buy/Send stored value for purchases throughout this website.`,
    onSendClick: () => pageStore.set(Pages.SEND_TOKENS),
    sendValueButtonText: `Send stored value`,
    isSendValueDisabled: !balance,
    onPaymentClick: goToPayment,
    maxStoredValueToPurchase,
    minStoredValueToPurchase,
  }}
/>
